import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import Pluralize from 'react-pluralize';
import { Tooltip, makeStyles } from '@material-ui/core';
import LayoverInfo from './LayoverInfo';
import formatDuration from '../../../../../../helpers/formatters/formatDuration';
import calculateDuration from '../../../../../../helpers/formatters/calculateDuration';

const useStyles = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    fontFamily: 'var(--fontFamilyBody)',
    backgroundColor: theme.palette.common.black,
    marginBottom: '5px',
    fontSize: '12px',
  },
}));
const useTooltipStyle = makeStyles(() => ({
  tooltip: {
    fontFamily: 'var(--fontFamilyBody)',
  },
}));

const OneWayFlightInfo = ({ flightSegment }) => {
  const tooltipClasses = useStyles();
  const classes = useTooltipStyle();
  return (
    <div className="md:grid grid-cols-9">
      <div className="grid grid-cols-8 col-span-5 md:col-span-4 email-inline-block">
        <img
          src={`${flightSegment.flights[0].carrierImage}`}
          alt={flightSegment.carrier}
          className="mr-2 w-10 col-span-1 email-inline-block"
        />
        <div className="col-span-7 lg:block xl:block flex flex-wrap ml-2 email-inline-block email-ml-20 email-vertical-align-top">
          <span className="whitespace-nowrap">
            {dayjs(flightSegment.departureDateTime).format('ddd, MMM D: ')}
          </span>
          &nbsp;
          <span className="whitespace-nowrap">
            {dayjs(flightSegment.departureDateTime).format('h:mm A')} -{' '}
            {dayjs(flightSegment.arrivalDateTime).format('hh:mm A')}
          </span>
          {calculateDuration(flightSegment.departureDateTime, flightSegment.arrivalDateTime) && (
            <Tooltip
              arrow
              title={`Arrive on ${dayjs(flightSegment.arrivalDateTime).format('dddd, MMMM D')}`}
              placement="top"
              enterTouchDelay={0}
              classes={classes}
            >
              <sup className="text-red-500 ml-1 font-bold text-xs basis-full my-2 lg:basis-auto lg:my-0">
                {calculateDuration(flightSegment.departureDateTime, flightSegment.arrivalDateTime)}{' '}
                (Arrives {dayjs(flightSegment.arrivalDateTime).format('MMM D')})
              </sup>
            </Tooltip>
          )}
          <div className="text-gray-500 w-full">
            <div className="md:text-center text-left col-span-2 block md:hidden email-hidden-field">
              <div className="text-gray-500">
                {flightSegment.originAirportCode} - {flightSegment.destinationAirportCode}
              </div>
              {formatDuration(flightSegment.durationInMin)}
            </div>
            {flightSegment.carrier}
            <div className="inline md:hidden email-hidden-field">
              {' '}
              <Pluralize singular="stop" count={flightSegment.stops} zero="nonstop" />
            </div>
          </div>
        </div>
      </div>
      <div className="text-center md:col-span-2 hidden md:block">
        <div className="hidden md:block">
          <Pluralize singular="stop" count={flightSegment.stops} zero="Nonstop" />
        </div>
        <div className="text-gray-500">
          {flightSegment.flights.map((stop, index) => (
            <LayoverInfo
              key={`${stop.originAirportCode}-${stop.departureDateTime}`}
              stop={stop}
              index={index}
              flights={flightSegment.flights}
              tooltipClasses={tooltipClasses}
            />
          ))}
        </div>
      </div>
      <div className="text-center col-span-2 hidden md:block">
        {formatDuration(flightSegment.durationInMin)}
        <div className="text-gray-500">
          {flightSegment.originAirportCode} - {flightSegment.destinationAirportCode}
        </div>
      </div>
    </div>
  );
};

OneWayFlightInfo.propTypes = {
  flightSegment: PropTypes.objectOf(PropTypes.objectOf).isRequired,
};

export default OneWayFlightInfo;
